import { render, staticRenderFns } from "./IncomeStep.vue?vue&type=template&id=3bc48d97&"
import script from "./IncomeStep.vue?vue&type=script&lang=js&"
export * from "./IncomeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports